namespace $ {
	/** Durable queue. The worker owns execution; opening this view never runs tests. */
	export class $shm_hitalama_components_tests_service extends $mol_object {
		definition() { return null as any as $shm_hitalama_map_widget_entity_custom }
		private commands = new WeakMap<object, { id: string, text: string, done?: boolean, run?: $shm_hitalama_components_scenario_run }>()
		@ $mol_mem
		scenarios() { return new this.$.$shm_hitalama_components_scenario_service }
		allocate( scenario: $shm_hitalama_components_scenario, id: string ) {
			return scenario.land().area_make( $mol_hash_string( 'playwright-run:' + id ) ).Data( $shm_hitalama_components_scenario_run )
		}
		@ $mol_action
		enqueue( event: object, id: string ) {
			const definition = this.definition(), name = definition.class_name()
			const scenario = this.scenarios().scenario( name, id )
			if( !definition.can_change() || !scenario.can_change() ) throw new Error( 'Нет прав на запуск теста.' )
			const current = scenario.Spec()?.val() ?? ''
			const spec = $shm_hitalama_components_scenario.validate( current )
			if( spec.runner !== 'playwright' ) throw new Error( 'Это старый сценарий браузера клиента. Для независимого запуска сохраните runner: playwright.' )
			if( spec.mode !== 'demo' ) throw new Error( 'Независимый исполнитель пока поддерживает только demo: реальные данные не изменяются.' )
			let command = this.commands.get( event )
			if( !command ) { command = { id: crypto.randomUUID(), text: current }; this.commands.set( event, command ) }
			if( command.done ) return command.id
			if( command.text !== current ) throw new Error( 'Сценарий изменился во время запуска. Повторите явно.' )
			const hash = $mol_wire_sync( this.scenarios() ).source_hash( name )
			const run = command.run ??= $mol_wire_sync( this ).allocate( scenario, command.id )
			if( !run.Data()?.val() ) {
				run.Spec( null )!.val( command.text )
				run.Data( null )!.val( JSON.stringify({ run_id: command.id, name, id, title: spec.title, runner: 'playwright', status: 'queued', queued: new Date().toISOString(), source_hash: hash, steps: [] }) )
			}
			scenario.Runs( null )!.key( command.id, null )!.remote( run )
			scenario.Pending( null )!.key( command.id, null )!.remote( run )
			command.done = true
			return command.id
		}
	}
}
